import { ref } from 'vue';

const preventAnimation = ref(false);

// avoid accordion tab animation flick
export default function usePreventAnimation() {
  const setPreventAnimation = (val) => {
    preventAnimation.value = val;
  };

  return {
    preventAnimation,
    setPreventAnimation,
  };
}
